import CharCodes from "./CharCodes";
export var IsWhitespace = new Uint8Array(256);
IsWhitespace[CharCodes.Null] = 1;
IsWhitespace[CharCodes.Tab] = 1;
IsWhitespace[CharCodes.Newline] = 1;
IsWhitespace[CharCodes.FormFeed] = 1;
IsWhitespace[CharCodes.CarriageReturn] = 1;
IsWhitespace[CharCodes.Space] = 1;
//# sourceMappingURL=Whitespace.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/pdf-lib/es/core/syntax/Whitespace.js
// module id = 510
// module chunks = 0